import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";
import "./overview.css";
import "./snapshots.css";
import "./admin.css";
import "./responsive.css";
import "./feeder-setup.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
